import { render } from "./RechargeKkiaPay.vue?vue&type=template&id=e90a5f32&scoped=true&ts=true"
import script from "./RechargeKkiaPay.vue?vue&type=script&lang=ts"
export * from "./RechargeKkiaPay.vue?vue&type=script&lang=ts"

import "./RechargeKkiaPay.vue?vue&type=style&index=0&id=e90a5f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90a5f32"]])

export default __exports__